
import React from 'react';
import TreatmentPageTemplate from './TreatmentPageTemplate';

const Kybella = () => {
  const treatmentData = {
    title: "Kybella",
    subtitle: "Non-surgical double chin reduction with lasting results",
    description: "Kybella is the only FDA-approved injectable treatment that destroys fat cells under the chin. This revolutionary treatment provides permanent results with no surgery or downtime required.",
    whoItsFor: [
      "Adults with moderate to severe submental fat",
      "Those seeking non-surgical chin contouring",
      "People bothered by their double chin",
      "Clients wanting permanent fat reduction",
      "Anyone looking to improve their jawline definition"
    ],
    packages: [
      {
        name: "Single Treatment",
        visitorPrice: "$1,200",
        memberPrice: "$1,080",
        description: "One Kybella treatment session"
      },
      {
        name: "Complete Series",
        visitorPrice: "$3,000",
        memberPrice: "$2,700",
        description: "Package of 3 treatments for optimal results"
      },
      {
        name: "Touch-Up Session",
        visitorPrice: "$800",
        memberPrice: "$720",
        description: "Additional treatment for fine-tuning results"
      }
    ],
    beforeCare: [
      "Avoid blood thinners for 1 week",
      "No anti-inflammatory medications",
      "Avoid alcohol 24 hours prior",
      "Eat a light meal before treatment"
    ],
    duringCare: [
      "Precise mapping and marking",
      "Multiple small injections",
      "30-45 minute treatment time",
      "Ice and numbing for comfort"
    ],
    afterCare: [
      "Swelling is normal for 1-2 weeks",
      "Apply ice regularly first 48 hours",
      "Avoid strenuous exercise for 24 hours",
      "Follow-up appointment in 6 weeks"
    ],
    memberPerks: [
      "10% discount on Kybella packages",
      "Complimentary consultation and assessment",
      "Priority scheduling for series treatments",
      "Free post-treatment lymphatic massage",
      "Access to exclusive recovery products"
    ]
  };

  return <TreatmentPageTemplate {...treatmentData} />;
};

export default Kybella;
